class Language {
    constructor(wikidataID, wikidataLabel, ietfLanguageTag, nativeLabels, customLabel, customLanguageCode) {
        this.wikidataID = wikidataID || ''; // wikidata node
        this.wikidataLabel = wikidataLabel || ''; // wikidata label in English
        this.ietfLanguageTag = ietfLanguageTag || ''; // language tag
        this.nativeLabels = nativeLabels || ''; // native label
        this.customLabel = customLabel || ''; // user defines their own language
        this.customLanguageCode = customLanguageCode || ''; // user defines their own language
    }
}

export default Language;